import { useSelector } from 'react-redux';
import { RootState } from '..';

export const selectLaunchDarkly = (state: RootState) => state.launchDarkly.data;
export const useLaunchDarkly = () => useSelector(selectLaunchDarkly);
